export class SpinBox {
  constructor(inputField, onChange) {
    this.inputField = inputField;
    this.onChange = onChange;
    this.range = {min: 0, max: 100};
    this.defaultValue = 0;
    this.value = '';

    this.inputField.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.inputField.addEventListener('keyup', this.handleKeyUp.bind(this));
    this.inputField.addEventListener('change', this.handleDomValueChange.bind(this));
    this.syncDomInputField();
  }

  setRange(min, max) {
    this.range = {min: parseFloat(min), max: parseFloat(max)};
    return this;
  }

  setDefaultValue(value) {
    this.defaultValue = parseFloat(value);
    return this;
  }

  setValue(value) {
    this.value = parseFloat(value);
    this.correctValue();
    return this;
  }

  setToDefaultValue() {
    this.value = this.defaultValue;
  }

  setToMinValue() {
    this.value = this.range.min;
  }

  setToMaxValue() {
    this.value = this.range.max;
  }

  setStepSize(stepSize) {
    this.stepSize = parseFloat(stepSize);
    return this;
  }

  correctValue() {
    if (this.value === '' || isNaN(this.value)) {
      this.setToDefaultValue();
    }

    this.value = parseFloat(this.value);
  }

  increaseValue() {
    this.correctValue();

    this.value += this.stepSize;
    if (this.value > this.range.max) {
      this.setToMaxValue();
    }
  }

  decreaseValue() {
    this.correctValue();

    this.value -= this.stepSize;
    if (this.value < this.range.min) {
      this.setToMinValue();
    }
  }

  syncDomInputField() {
    this.inputField.value = this.value;
    this.inputField.setAttribute('aria-valuenow', this.value);
  }

  handleKeyDown(event) {
    switch (event.key) {
      case 'ArrowUp':
        this.increaseValue();
        break;
      case 'ArrowDown':
        this.decreaseValue();
        break;
      case 'Home':
        this.setToMinValue();
        break;
      case 'End':
        this.setToMaxValue();
        break;
      case 'Space':
        this.setToDefaultValue();
        break;
      default:
        return;
    }

    this.syncDomInputField();
  }

  handleKeyUp() {
    this.handleDomValueChange();
  }

  handleDomValueChange() {
    this.value = parseFloat(this.inputField.value.replace(',', '.'));
  }
}
